/** Country data schema for the africanDRONE map */

export type RegulationStatus = 'straightforward' | 'complicated' | 'very_difficult' | 'no_data';

export interface CountryData {
  iso3: string;
  iso2: string;
  name: string;
  flag: string;
  continent: string;
  regulation_status: RegulationStatus;
  regulations: {
    summary: string;
    summary_html: string;
    intro_html?: string;
    quick_links?: Array<{ label: string; url: string }>;
    last_updated: string | null;
    last_reviewed?: string | null;
    source_urls: string[];
  };
  aviation_authority: {
    name: string;
    html: string;
    url: string | null;
    email: string | null;
    phone: string | null;
  };
  contacts: {
    verified_pilots: string;
    verified_pilots_html: string;
    verified_fixers: string;
    verified_fixers_html: string;
    social_media: string;
    social_media_html: string;
    whatsapp: string;
  };
  resources: Array<{ title: string; url: string }>;
  /** US state-level regulation data (only present for USA) */
  us_states?: USStateData[];
}

export interface USStateData {
  code: string;
  name: string;
  categories: Array<{
    name: string;
    links: Array<{ title: string; url: string }>;
  }>;
}

/** Status display config – "Ease of Flight" rating */
export const STATUS_CONFIG: Record<RegulationStatus, { label: string; color: string }> = {
  straightforward: { label: 'Straightforward', color: '#22c55e' },
  complicated: { label: 'Complicated', color: '#eab308' },
  very_difficult: { label: 'Very Difficult', color: '#f97316' },
  no_data: { label: 'No Data', color: '#6b7280' },
};
